import { useState } from 'react';

import { AlertDialogTitleHeader } from '@/components/molecules/alert-dialog-title-header';
import { CriticalAlertIcon } from '@/components/molecules/critical-alert-icon';
import { TooltipButton } from '@/components/molecules/tooltip-button';
import { useShutdownActionPermission } from '@/components/shutdown-banner/use-shutdown-action-permission';
import { useRestartShutdown } from '@/hooks/query-hooks/gaia-api/shutdown-banner';
import { useCurrentFacility } from '@/hooks/use-current-facility';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogBody,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogFooterButtons,
  AlertDialogTrigger,
} from '@/ux-common/components/alert-dialog/alert-dialog';
import { Button } from '@/ux-common/components/button/button';
import { Typography } from '@/ux-common/components/typography/typography';

export const RestartBuildingAction = () => {
  const { agentId } = useCurrentFacility();
  const { mutate: restartShutdown, isPending } = useRestartShutdown({ agentId });
  const { isDisabled, tooltipText } = useShutdownActionPermission();
  const [open, setOpen] = useState(false);

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <TooltipButton
          className="btn btn-inverse"
          data-component="RestartBuildingAction"
          disabled={isDisabled}
          showTooltipWhenEnabled
          tooltipContent={tooltipText}
        >
          {'Restart Building'}
        </TooltipButton>
      </AlertDialogTrigger>
      <AlertDialogContent data-component="RestartBuildingDialog" className="dialog-md">
        <AlertDialogTitleHeader
          icon={<CriticalAlertIcon />}
          title={'Are you sure you want to Restart your Building?'}
        />
        <AlertDialogBody>
          <AlertDialogDescription asChild>
            <Typography as="p" className="text-body-base">
              Restarting will significantly increase your monthly energy costs due to high rates,
              peak demand, and active cost-control measures.
            </Typography>
          </AlertDialogDescription>
        </AlertDialogBody>
        <AlertDialogFooter>
          <AlertDialogFooterButtons>
            <AlertDialogCancel asChild>
              <Button type="button" className="btn-tier3" disabled={isPending}>
                {'Do Not Restart Building'}
              </Button>
            </AlertDialogCancel>
            <AlertDialogAction asChild>
              <Button
                type="button"
                className="btn-destructive"
                disabled={isPending}
                onClick={(event) => {
                  // Radix closes on click unless the handler prevents it; stay open
                  // so the pending label shows and a failed restart keeps the dialog up.
                  event.preventDefault();
                  restartShutdown({}, { onSuccess: () => setOpen(false) });
                }}
              >
                {isPending ? 'Restarting...' : 'Yes, Restart Building'}
              </Button>
            </AlertDialogAction>
          </AlertDialogFooterButtons>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
